import req from '../lib/req';
import { BankAccount, Id } from '@/types';

export async function findById(id: Id): Promise<BankAccount> {
  return await req.get(`/bank-account/${id}`).then((response) => response.data);
}
